import CardComponent from "./CardComponent";

export class Distance extends CardComponent {

    getOptions = (createHtmlData) => {
        super.getOptions(createHtmlData ?? null);
        this.options.locale_is_gb = window.Bark.LOCALE.iso2c === 'gb';
        return this.options;
    }
}
